<template>    
	<el-drawer
	    title="购买演出音乐风格偏好"
	    :visible.sync="drawerShow"
	    :wrapperClosable="false"
	    :destroy-on-close="true"
	    size="500px"
	    @close="close"
	>
        <div class="drawer-content" >
            <div id="musicChart" ref="musicChart"></div>
        </div>
        <div class="drawer-footer">           
            <el-button @click="close()">关 闭</el-button>
        </div>
    </el-drawer>
</template>
<script>
import { Chart } from '@antv/g2';
export default {   
    props: {
       data: {
           type: Object,
           default: null
       }
    },
   
    data(){
        return {
			drawerShow:false,
            pageLoading: true,
			chartDatas:{},
			Chart1:null
                     
        }
    },
    methods: {
        show(data) {
            this.drawerShow = true;
			this.chartDatas = data
			
			this.$nextTick(() => {
			    this.musicStyleStaShow();			  
			})
        },
        close(){            
            this.drawerShow = false;			
        },
		musicStyleStaShow(){				   
			if( this.Chart1 ) this.Chart1.destroy();
			
			let _data = [];
			_data = [...this.chartDatas.portraitInfo.musicStyleSta];
			
			
			this.Chart1 = new Chart({
				container: 'musicChart',
				autoFit: true,
				height: 420,				
			});
			this.Chart1.coordinate('theta', {
				radius: 0.6,
			});
			
			this.Chart1.data(_data);
			this.Chart1.scale('value', {
				formatter: (val) => {
					val = (val * 100).toFixed(2) + '%';
					return val;
				},
			});
			
			this.Chart1.tooltip({
				showTitle: false,
				showMarkers: false,
			});
			
			this.Chart1.legend('name', {
				position: 'top',
			});
			this.Chart1
				.interval()
				.adjust('stack')
				.position('value')
				.color('name')
				.label('value', (val) => {
					return {
						// offset: val > 0.05 ? -30 : null,
						content: (obj) => {
							return obj.name //+ ':' + (obj.percent * 100).toFixed(2) + '%';
						},
					};
				})
				.tooltip('name*value', (name, value) => {
					
					return {
						name: name,
						value: value,
					};
				});
			this.Chart1.render();
		},
		
		
    }
}
</script>
<style lang="scss" scoped>

</style>